// extracted by mini-css-extract-plugin
module.exports = {"consideredPhone":"576px","tableHightlightColor":"wheat","tableHightlightColorSecondary":"#bcf7ff"};